import React from "react";
import Column from "@amzn/meridian/esm/components/column";
import Text from "@amzn/meridian/esm/components/text";
import { TRANSCRIPTION_STATES } from "../../constants";
import TranscribingIndicator from "./TranscribingIndicator";
import TranscribeStopped from "./TranscribeStopped";
import TranscribeRestarting from "./TranscribeRestarting";

/**
 * Unified indicator component that handles all different states of the transcription process
 * This component consolidates the rendering logic for different transcribe states into one place
 */
const TranscribeBoxIndicator = ({
  transcriptionState,
  rtmsRequesterName,
  isRtmsStartedByOther,
  isRestarting
}) => {
  return (
    <>
      {/* LOADING state when transcription is being restarted due to rtms error */}
      {transcriptionState === TRANSCRIPTION_STATES.LOADING && isRestarting && (
        <TranscribeRestarting />
      )}

      {/* REJECTED state - someone else is starting transcription */}
      {transcriptionState === TRANSCRIPTION_STATES.REJECTED && rtmsRequesterName && (
        <Column spacing="none">
          <Text type="h50" color="secondary" alignment="start">
            {rtmsRequesterName}
          </Text>
          <Text type="b200" color="secondary" alignment="start">
            is starting transcription
          </Text>
        </Column>
      )}

      {/* STOPPED state - transcription has ended */}
      {transcriptionState === TRANSCRIPTION_STATES.STOPPED && (
        <TranscribeStopped />
      )}

      {/* TRANSCRIBING state - actively transcribing */}
      {transcriptionState === TRANSCRIPTION_STATES.TRANSCRIBING && (
        <TranscribingIndicator 
          rtmsRequesterName={rtmsRequesterName} 
          isRtmsStartedByOther={isRtmsStartedByOther}
        />
      )}
    </>
  );
};

export default TranscribeBoxIndicator;
